import widgetsModule from './widgets.module'
export default widgetsModule.name
